<template>
  <v-tabs v-model="currentTab" dark left :centered="false" :scrollable="true">
      <confirm-modal :dialog="confirmModal" :message="confirmModalMessage" @confirm="confirmResponse"></confirm-modal>
    <v-toolbar extended color="green" dark>
      <v-toolbar-title slot="extension" v-cloak style="display: flex">
          <h3>{{ editMode ? currentTournament.name : 'Torneo sin nombre' }}</h3>
          <v-btn
            color="red"
            v-if="editMode && this.currentTournament.status != 'finalized'"
            @click="confirmModal = true"
            >
                Finalizar Torneo
            </v-btn>
      </v-toolbar-title>
    </v-toolbar>
    <v-tabs-bar class="green" left>
      <v-tabs-slider color="white"></v-tabs-slider>
      <v-tabs-item
        @click.stop.prevent="selectTab(tab.key)"
        v-for="tab in tabs"
        :key="tab.key"
        :href="'#' + hrefTab(tab.key)"
        :disabled="disableTab(tab.key)">

        {{ tab.title }}
      </v-tabs-item>
    </v-tabs-bar>
    <v-tabs-items :touchless="true">
        <v-tabs-content :key="'infoG'" :id="'infoG'">
            <general-information v-if="activeTab == 'infoG'"></general-information>
        </v-tabs-content>
        <v-tabs-content :key="'teams'" :id="'teams'">
            <teams v-if="activeTab == 'teams'"></teams>
        </v-tabs-content>
        <v-tabs-content :key="'calendar'" :id="'calendar'">
            <tournament-calendar v-if="activeTab == 'calendar'"></tournament-calendar>
        </v-tabs-content>
        <v-tabs-content :key="'scores'" :id="'scores'">
            <scores v-if="activeTab == 'scores'"></scores>
        </v-tabs-content>
        <v-tabs-content :key="'statistics'" :id="'statistics'">
            <statistics :tournamentid="tournamentId" v-if="activeTab == 'statistics'"></statistics>
        </v-tabs-content>
        <v-tabs-content v-if="false" :key="'accountStatus'" :id="'accountStatus'">
            <account-status v-if="activeTab == 'accountStatus'"></account-status>
        </v-tabs-content>
        <v-tabs-content v-if="currentTournament.is_femexfut" :key="'sanctions'" :id="'sanctions'">
            <sanctions v-if="activeTab == 'sanctions'"></sanctions>
        </v-tabs-content>
    </v-tabs-items>
  </v-tabs>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Tournament from '@/models/tournament'
import ConfirmModal from '@/components/helpers/modals/ConfirmModal'
import Bus from '@/components/bus'

export default {
    name: 'TournamentForm',
    data() {
        return {
            tabs: [
                { key: 'infoG', title: 'INFORMACIÓN GENERAL' },
                { key: 'teams', title: 'EQUIPOS' },
                { key: 'calendar', title: 'CALENDARIO' },
                { key: 'scores', title: 'CAPTURA RESULTADO' },
                { key: 'statistics', title: 'ESTADISTICAS' },
                { key: 'sanctions', title: 'SANCIONES' }/*,
                { key: 'accountStatus', title: 'ESTADO DE CUENTA' }*/
            ],
            currentTab:'infoG',
            tournamentId : -1,
            editMode: false,
            activeTab: 'infoG',
            confirmModal: false,
            confirmModalMessage: '¿Estas seguro de finalizar el torneo?'
        }
    },
    computed: {
        ...mapGetters([
            'currentTournament',
            'isCalendarEdited'
        ]),
        routeChanges() {
            if(this.$route.params.tournamentID) this.editMode = true

            return this.$route.params.tournamentID
        }
    },
    methods: {
        ...mapActions([
            'findTournament',
            'finalizeTournament'
        ]),
        selectTab(tab) {
          console.log("CURRENT",this.currentTab,)

          /*FIX LOCO PARA*/
          if(this.isCalendarEdited){
            this.activeTab = 'calendar'
            setTimeout(()=>{ this.currentTab = "calendar" }, 100);
            Bus.$emit(Bus.ACTION_SHOW_ALERT, { title: "Datos sin guardar", msg: "Para ir a otra pestaña necesita guardar o cancelar los cambios en el calendario" })
            return
          }

            this.activeTab = tab

        },
        disableTab(tab) {
            return !this.editMode && tab != 'infoG'
        },
        hrefTab(tab){
            /*if(this.currentTab =='calendar'){
              return 'calendar'
            }*/
            return tab
        },
        confirmResponse(response) {
            console.log(response)
            this.confirmModal = false
            if(response) {
                this.finalizeTournament(this.$route.params.tournamentID)
            }
        }
    },
    watch: {
        routeChanges(val) {
        }
    },
    mounted() {
        if(this.$route.params.tournamentID){
            this.editMode = true
            this.tournamentId = this.$route.params.tournamentID
        }else{
          this.tournamentId = -1
        }
    }

}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/components/pages/tournaments/tournamentForm.vue